import moment from 'moment-timezone';
import { AppConstants } from '../../../../shared/Constants';

export const getTypeDisplayName = (type) => {
  switch (type) {
    case 'OWNER_TERMS_OF_USE':
      return 'Owner Terms of Use';
    case 'DATA_PROCESSING_AGREEMENT':
      return 'Data Processing Agreement';
    case 'USER_TERMS_OF_USE':
      return 'User Terms of Use';
    case 'GR8PI_RESPONDENT_TERMS_OF_USE':
      return 'Respondent Terms of Use';
    case 'GROW_RESPONDENT_TERMS_OF_USE':
      return 'GROW Respondent Terms of Use';
    case 'PRIVACY_POLICY':
      return 'Privacy Policy';
    case 'GR8PI_TERMS_OF_SERVICE':
      return 'GR8PI Terms of Service';
    case 'GROW_TERMS_OF_SERVICE':
      return 'GROW Terms of Service';
    case 'GR8PI_SERVICE_LEVEL_AGREEMENT':
      return 'GR8PI Service Level Agreement';
    case 'GR8PI_INTERNAL_SUPPORT_PROCEDURE':
      return 'GR8PI Internal Support Procedure';
    case 'GPI_PARTNER_AGREEMENT':
      return 'GPI Partner Agreement';
    default:
      return '';
  }
};

export const buildDocumentsDisplayNames = (importantDeclinedDocuments) => {
  let documentDisplayNames = '';

  for (let i = 0; i < importantDeclinedDocuments.length; i++) {
    const displayName = getTypeDisplayName(importantDeclinedDocuments[i]);

    if (i === 0) {
      documentDisplayNames = displayName;
    } else {
      documentDisplayNames = documentDisplayNames + `, ${displayName}`;
    }
  }

  return documentDisplayNames;
};

export const computeEnforcedOnDate = (type, scheduledOn) => {
  const scheduledOnInUTC = new Date(
    Date.UTC(scheduledOn.getFullYear(), scheduledOn.getMonth(), scheduledOn.getDate(), 0, 0, 0, 0),
  );

  if (type === 'OWNER_TERMS_OF_USE' || type === 'DATA_PROCESSING_AGREEMENT') {
    const enforcedOnDate = new Date(scheduledOnInUTC);
    enforcedOnDate.setDate(enforcedOnDate.getDate() + 45);

    return moment(enforcedOnDate).format(AppConstants.GSC_DASHBOARD_DATETIME_INPUT_FORMAT);
  }

  return moment(scheduledOnInUTC).format(AppConstants.GSC_DASHBOARD_DATETIME_INPUT_FORMAT);
};
